/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataConstraint {
  /** unique or primary key constraint on columns "calendar_event_udf_default_data_id" */
  CalendarEventUdfDefaultDataPkey = 'calendar_event_udf_default_data_pkey',
  /** unique or primary key constraint on columns "schedule_event_id", "udf_column_id", "context_id" */
  CalendarEventUdfDefaultDataUnique = 'calendar_event_udf_default_data_unique'
}

/** select columns of table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

